Vendd.Scripts.load(function () {

    var $form = $('.x-requestorderchange-form'),
        form;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    var formData = {
        email: "",
        orderCode: ""
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;

        if (data) {
            $('.js-error', $form).hide();

            var redirectUrl = $('.x-requestorderchange-form').data('redirect');

            if (redirectUrl != undefined && redirectUrl != '') {

                document.location = redirectUrl;
            }
        } else {
            $('.js-error', $form).show();
        };
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
    };

    form.submit = function () {
        form.loading(true);

        $('input[name]:not([type="checkbox"]):not([type="radio"])', $form).each(function () {
            formData[$(this).attr('name')] = $(this).val();
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.Order.Messages.SubmitRequestOrderChange(formData.email, formData.orderCode));
    };

    form.checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox');
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Request Order Change Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            form.submit();
        }
    }

    $form.on('keyup', 'input[name]', function (e) {
        if (e.keyCode == 13) {

            if ($(this).prop("tagName").toLowerCase() === "textarea")
                return true;

            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        rop.validate(fieldName);
    });

    $(".js-submit-button").on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val = rop.validate();

        if (val) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                form.submit();
            }
        }
    });

    //init validation options
    var validationOptions = {
        email: {
            required: 'email-required',
            isEmail: 'email-invalid'
        },
        orderCode: {
            required: 'order-code-required'
        }
    };

    //add consent validations
    $.each($('div.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el).attr('name');
        validationOptions[consentType] = {
            checkboxRequired: consentType + '-required'
        };
    });

    $form.validationEngine(validationOptions);
    var rop = $form.data('validationEngine');

    var $consents = $('.form-row.consent input[type="checkbox"]', $form);

    $consents.on('click', function () {
        var fieldName = $(this).attr('name');

        rop.validate(fieldName);
    });

    if ($(".view-terms", $form).length > 0) {
        $(".view-terms", $form).fancybox({
            touch: false
        });
    }

    Vendd.MessageBus.subscribe(Vendd.Order.Messages.SubmitRequestOrderChangeSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Order.Messages.SubmitRequestOrderChangeFailure, form, form.onFailure);

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submit);
});

